module.exports = __webpack_public_path__ + "img/05-เปลี่ยนแปลงแก้ไขโทรศัพท์.b5801d69.png";